import { isAccountClaim, isCouponClaim } from "@api/models/IClaim";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Modal } from "@mantine/core";
import useRewardModalStore from "@store/rewardModal.store";
import { useCallback } from "react";
import AccountModalBody from "./rewardModalComponents/AccountModalBody";
import CouponModalBody from "./rewardModalComponents/CouponModalBody";

const RewardModal: React.FC = () => {
  const { isOpened, item, close } = useRewardModalStore();
  const { t } = useAppTranslation();

  const getModalBody = useCallback(() => {
    if (!item) return <></>;

    if (isAccountClaim(item)) return <AccountModalBody item={item} />;
    if (isCouponClaim(item)) return <CouponModalBody item={item} />;
  }, [item]);

  return (
    <Modal
      centered
      zIndex={300}
      classNames={{
        content: "bg-primary-background select-none rounded-lg",
        body: "px-2 xs:px-4 py-4 bg-primary-client overflow-y-auto overflow-x-hidden",
        header: "bg-primary-default shadow-lg",
        title: "w-full text-center",
      }}
      closeButtonProps={{ className: "default-icon" }}
      opened={isOpened}
      title={
        <>
          <SSWhiteText
            className="pb-2 font-bold font-secret text-xl"
            span={false}
          >
            Récompense Débloqué ! 🎉
          </SSWhiteText>
          <SSLoLGradientText className="font-bold font-secret" span={false}>
            {item && t(`${item.i18nKey}.label`)}
          </SSLoLGradientText>
        </>
      }
      onClose={close}
    >
      {getModalBody()}
    </Modal>
  );
};

export default RewardModal;
